import {DEFAULT_STYLE, NORMALIZED_STYLE} from '../constant';
import {PartialFrameElements} from '../type/PartialFrameElements.interface';

export function initializeFrameElements({
  shadowHostElement,
  defaultStyleElement,
}: PartialFrameElements) {
  shadowHostElement.style.position = '';
  shadowHostElement.style.width = '';
  shadowHostElement.style.height = '';
  shadowHostElement.style.backgroundColor = '';
  shadowHostElement.style.padding = '';
  shadowHostElement.style.left = '';
  shadowHostElement.style.visibility = 'visible';

  defaultStyleElement.innerHTML = `${NORMALIZED_STYLE}\n${DEFAULT_STYLE}`;
}
